import { GRAPHICAL_REPORTS, REPORTS, HOME_SUMMARY } from "../config";
import { get } from "./apiHelper";

export const fetchReportsByCode = (code, tab) => {
  const endpoint = tab === "graphical-reports" ? GRAPHICAL_REPORTS : REPORTS;
  return get(`${endpoint}${code}`);
};

export const fetchReportsData = (query) => 
  get(`${REPORTS}data/${query.id}?start_date=${query.start_date}&end_date=${query.end_date}`);

export const fetchGraphicalReportsData = (reports) =>
  get(`${GRAPHICAL_REPORTS}data/${reports.id}?start_date=${reports.start_date}&end_date=${reports.end_date}`);

export const fetchHomeSummary = (date) =>
  get(`${HOME_SUMMARY}?start_date=${date.start_date}&end_date=${date.end_date}`);
